<template>
  <v-list-item @click.stop="$emit('input', !dense)">
    <v-list-item-title>Dense display</v-list-item-title>
    <v-list-item-action><v-icon small class="mr-1" v-if="dense">mdi-check</v-icon></v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'DenseDisplay',
  props: {
    value: {type:Boolean, required:true},
    name: {type:String, required:true}
  },
  data() {
    return {
      dense: false
    }
  },
  watch: {
    value() {
      this.dense = this.value;
      localStorage.setItem(`${this.name}.dense`, this.dense?'1':'0');
    }
  },
  created() {
    const dense = localStorage.getItem(`${this.name}.dense`)==='1' || this.dense;
    this.$emit('input', dense);
  }
}
</script>